import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import React, { useContext } from 'react';
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $9bf71ea28793e738$var$FocusContext =
/*#__PURE__*/
React.createContext(null);

function $9bf71ea28793e738$export$10c5169755ce7bd7() {
  var _useContext;

  return (_useContext = useContext($9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}

function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  if (!element) return false;
  if (!scope) return false;
  return scope.some(function (node) {
    return node.contains(element);
  });
}

var $9bf71ea28793e738$var$Tree =
/*#__PURE__*/
function () {
  _createClass($9bf71ea28793e738$var$Tree, [{
    key: "getTreeNode",
    value: function getTreeNode(data) {
      return this.fastMap.get(data);
    }
  }, {
    key: "addTreeNode",
    value: function addTreeNode(scopeRef, parent, nodeToRestore) {
      var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
      if (!parentNode) return;
      var node = new $9bf71ea28793e738$var$TreeNode({
        scopeRef: scopeRef
      });
      parentNode.addChild(node);
      node.parent = parentNode;
      this.fastMap.set(scopeRef, node);
      if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
  }, {
    key: "addNode",
    value: function addNode(node) {
      this.fastMap.set(node.scopeRef, node);
    }
  }, {
    key: "removeTreeNode",
    value: function removeTreeNode(scopeRef) {
      // never remove the root
      if (scopeRef === null) return;
      var node = this.fastMap.get(scopeRef);
      if (!node) return;
      var parentNode = node.parent; // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
      // if we are, then replace the siblings restore with the restore from the scope we're removing

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var current = _step.value;
          if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var children = node.children;

      if (parentNode) {
        parentNode.removeChild(node);
        if (children.size > 0) children.forEach(function (child) {
          return parentNode && parentNode.addChild(child);
        });
      }

      this.fastMap["delete"](node.scopeRef);
    } // Pre Order Depth First

  }, {
    key: "traverse",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function traverse() {
      var node,
          _iteratorNormalCompletion2,
          _didIteratorError2,
          _iteratorError2,
          _iterator2,
          _step2,
          child,
          _args = arguments;

      return _regeneratorRuntime.wrap(function traverse$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              node = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.root;

              if (!(node.scopeRef != null)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return node;

            case 4:
              if (!(node.children.size > 0)) {
                _context.next = 30;
                break;
              }

              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 8;
              _iterator2 = node.children[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context.next = 16;
                break;
              }

              child = _step2.value;
              return _context.delegateYield(this.traverse(child), "t0", 13);

            case 13:
              _iteratorNormalCompletion2 = true;
              _context.next = 10;
              break;

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t1 = _context["catch"](8);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
              }

            case 25:
              _context.prev = 25;

              if (!_didIteratorError2) {
                _context.next = 28;
                break;
              }

              throw _iteratorError2;

            case 28:
              return _context.finish(25);

            case 29:
              return _context.finish(22);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, traverse, this, [[8, 18, 22, 30], [23,, 25, 29]]);
    })
  }, {
    key: "clone",
    value: function clone() {
      var _node_parent;

      var newTree = new $9bf71ea28793e738$var$Tree();

      var _node_parent_scopeRef;

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.traverse()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var node = _step3.value;
          newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return newTree;
    }
  }, {
    key: "size",
    get: function get() {
      return this.fastMap.size;
    }
  }]);

  function $9bf71ea28793e738$var$Tree() {
    _classCallCheck(this, $9bf71ea28793e738$var$Tree);

    this.fastMap = new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }

  return $9bf71ea28793e738$var$Tree;
}();

var $9bf71ea28793e738$var$TreeNode =
/*#__PURE__*/
function () {
  _createClass($9bf71ea28793e738$var$TreeNode, [{
    key: "addChild",
    value: function addChild(node) {
      this.children.add(node);
      node.parent = this;
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      this.children["delete"](node);
      node.parent = undefined;
    }
  }]);

  function $9bf71ea28793e738$var$TreeNode(props) {
    _classCallCheck(this, $9bf71ea28793e738$var$TreeNode);

    this.children = new Set();
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }

  return $9bf71ea28793e738$var$TreeNode;
}();

new $9bf71ea28793e738$var$Tree();
export { $9bf71ea28793e738$export$10c5169755ce7bd7 as useFocusManager };